import { memo } from "react";
import useLocale from "~/hook/useLocale";
import { ArticleType, categoryAndAutherProps } from "~/interface/article/article";
import { FALLBACK_IMAGE_URL } from "~/utils/constant";
import Tag from "../shared-components/Tag";
import ArticalImage from "./ArticalImage";
import ArticleNameAndDescription from "./ArticleNameAndDescription";
import ArticleReadMore from "./ArticleReadMore";

interface ArticleComponentProps {
  article: ArticleType;
  author: categoryAndAutherProps[];
  from?: string | null;
}

function ArticleComponent({ article, author, from }: ArticleComponentProps) {
  const autherName = author.find((author) => author.id === article.author);
  const { LocalizedLink } = useLocale();

  // Check if from is valid and not just empty strings
  const isNavigable = from && from.trim() !== "" && !from.includes("undefined") && !from.includes("null");
  const navigatePath = isNavigable ? `/${from}` : null;

  const content = (
    <>
      <ArticalImage
        thumb_img={{
          small: article.img?.s.url || FALLBACK_IMAGE_URL,
          medium: article.img?.m.url || FALLBACK_IMAGE_URL,
          large: article.img?.l.url || FALLBACK_IMAGE_URL,
          hd: article.img?.hd.url || FALLBACK_IMAGE_URL,
          original: article.img?.og.url || FALLBACK_IMAGE_URL,
        }}
        alt={article.title}
        ogImageIsNotAvailable={article.img ? true : false}
      />

      <div className="p-2 md:p-3">
        <ArticleNameAndDescription autherName={autherName ? autherName.text : null} date={article.write_date} title={article.title} description="" />
        <ArticleReadMore navigatePath={navigatePath} className="flex" />
      </div>

      {article.tag && (
        <div className="absolute top-1 right-1 z-[1]">
          <Tag text={article.tag} />
        </div>
      )}
    </>
  );

  if (!isNavigable || !navigatePath) {
    return <div className="bg-cardBgColor rounded-xl p-3 w-full flex flex-col gap-3 relative">{content}</div>;
  }

  return (
    <LocalizedLink to={navigatePath} className="bg-cardBgColor rounded-xl w-full flex flex-col relative cursor-pointer">
      {content}
    </LocalizedLink>
  );
}

export default memo(ArticleComponent);
